export const SEARCH_PARAMS_KEYS = {
  verificationId: 'verificationId',
  set: 'set',
  reset: 'reset',
  passwordChangeType: 'passwordChangeType',
  context: 'context',
  token: 'token',
  setPasswordType: 'setPasswordType',
  verificationRequestId: 'verificationRequestId',
  applicantUserId: 'applicantUserId',
  caseId: 'caseId',
  componentId: 'componentId'
};

export const PAGE_URLS = {
  forgotPassword: '/onboarding/forgot-password',
  passwordChanged: '/onboarding/password-changed?type=#{type}',
  home: '/dashboard/home',
  verificationDashboard: '/dashboard/verification',
  onBoardinSignin: '/onboarding/log-in',
  verificationDetails: `/dashboard/verification/verification-details?${SEARCH_PARAMS_KEYS.verificationId}=#{${SEARCH_PARAMS_KEYS.verificationId}}`,
  setPassword: `/onboarding/set-password`,
  resetPassword: `/onboarding/reset-password`,
  uploadDocument: '/document-tampering/upload-document',
  reports: '/document-tampering/report',
  faq: 'https://support.dataflowgroup.com/'
};

export const NON_LOGGED_IN_PAGE_URLS = [
  PAGE_URLS.onBoardinSignin,
  PAGE_URLS.forgotPassword,
  PAGE_URLS.passwordChanged.split('?')[0],
  PAGE_URLS.setPassword,
  PAGE_URLS.resetPassword
];

export const VERIFICATION_URLS = {
  selectCountry: '/verification/select-country',
  selectAuthority: '/verification/select-authority',
  pricingDetailsUrl: `/verification/pricing-details?verificationId=#{verificationId}`,
  verificationInsufficiency: `/verification/verification-insufficiency?verificationId=#{verificationId}`,
  uploadDocumentsForVerification:
    '/verification/document-upload?clientContractId=#{clientContractId}&applicantId=#{applicantId}',
  appealRequest:
    '/verification/appeal-request?verificationRequestId=#{verificationRequestId}',
  requestCorrection:
    '/verification/request-correction?verificationRequestId=#{verificationRequestId}',
  insufficiencyPricingEstimation:
    '/verification/insufficiency-pricing-details?verificationRequestId=#{verificationRequestId}&applicantUserId=#{applicantUserId}&insufficiency=true',
  approvalSent: `/verification/approval-sent?verificationRequestId=#{verificationRequestId}`,
  clientRequirementList:
    '/verification/client-requirement-list?verificationRequestId=#{verificationRequestId}&crlId=#{crlId}&applicantUserId=#{applicantUserId}',
  letterOfAuth: `/verification/letter-of-auth?verificationRequestId=#{verificationRequestId}&applicantUserId=#{applicantUserId}`,
  uploadDocumentsForEditComponent:
    '/verification/document-upload?verificationRequestId=#{verificationRequestId}&applicantUserId=#{applicantUserId}&componentId=#{componentId}',
  nameChange:
    '/verification/name-change?verificationRequestId=#{verificationRequestId}&applicantUserId=#{applicantUserId}',
  overview:
    '/verification/overview?verificationRequestId=#{verificationRequestId}&applicantUserId=#{applicantUserId}',
  overviewSummary:
    '/verification/overview-summary?verificationRequestId=#{verificationRequestId}',
  pricingEstimation:
    '/verification/pricing-estimate?verificationRequestId=#{verificationRequestId}&applicantUserId=#{applicantUserId}&componentId=#{componentId}',
  requiredDocuments: '/verification/required-documents',
  fetchReportReissuePricing:
    '/verification/reissue-report?verificationRequestId=#{verificationRequestId}',
  additionalComponents:
    '/verification/additional-components?verificationRequestId=#{verificationRequestId}&applicantUserId=#{applicantUserId}&parentVerificationRequestId=#{parentVerificationRequestId}'
};

export const DASHBOARD_URLS = {
  userProfile: '/dashboard/user-profile',
  verificationDetails: `/dashboard/verification/verification-details?verificationId=#{verificationId}`,
  insights: '/dashboard/insights',
  partnerHomePage: '/dashboard/home',
  evaluatorPerformance: '/dashboard/evaluator-performance',
  casesOverview: '/dashboard/analyticsDashboard/cases-overview',
  filteredCasesList:
    '/dashboard/analyticsDashboard/cases-overview/filtered-cases',
  filteredCasesListWithParams:
    '/dashboard/analyticsDashboard/cases-overview/filtered-cases?metricType=#{metricType}&from=#{from}&to=#{to}',
  reasoningDetails:
    '/dashboard/analyticsDashboard/cases-overview/reasoning-details?type=#{type}'
};

export const VERIFICATION_EXTRA_URLS = {
  country: 'country'
};

export const NOTIFICATIONS_URLS = {
  home: '/dashboard/home/notifications'
};
